import React from "react";
import { onlineManager } from "@tanstack/react-query";
import { Alert, Snackbar } from "@mui/material";
import WifiIcon from "@mui/icons-material/WifiOffOutlined";
import { useTranslation } from "react-i18next";

function OfflineIndicator() {
  const { t } = useTranslation();

  const [isOnline, setOnline] = React.useState(true);

  React.useEffect(() => {
    onlineManager.subscribe(() => {
      setOnline(onlineManager.isOnline());
    });
  }, []);

  return (
    <Snackbar
      open={!isOnline}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert
        icon={<WifiIcon />}
        variant="filled"
        color="gray"
        severity="warning"
      >
        {t("E.OFFLINE")}
      </Alert>
    </Snackbar>
  );
}

export default OfflineIndicator;
